"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const Portal_1 = require("~/components/UI/Portal");
const Scrollable_1 = require("~/components/UI/Scrollable");
const assets_1 = require("~/assets");
const SelectOption_1 = require("./SelectOption");
const Select_module_scss_1 = __importDefault(require("./Select.module.scss"));
function Select({ options, onChange = () => {
    /* do nothing */
}, selected, style, }) {
    var _a;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const selectRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const closeClickHandler = (event) => {
            if (selectRef.current &&
                ![...selectRef.current.children].some((child) => {
                    if (child === event.target) {
                        return true;
                    }
                    if (child.children && [...child.children].some((ch) => ch === event.target)) {
                        return true;
                    }
                    return false;
                })) {
                setIsOpen(false);
            }
        };
        if (selectRef.current) {
            window.addEventListener('click', closeClickHandler);
        }
        return () => {
            if (!selectRef.current) {
                window.removeEventListener('click', closeClickHandler);
            }
        };
    }, [selectRef.current]);
    const openOptionsHandler = () => {
        setIsOpen((current) => !current);
    };
    const selectHandler = (value) => {
        onChange(value);
        setIsOpen(false);
    };
    return (react_1.default.createElement("div", { ref: selectRef, className: Select_module_scss_1.default['container'] },
        react_1.default.createElement("div", { className: Select_module_scss_1.default['selected'], onClick: openOptionsHandler },
            selected ? (react_1.default.createElement("div", { className: selected.value === null ? Select_module_scss_1.default.placeholder : '' }, selected.label)) : (react_1.default.createElement("div", null, options[0].label)),
            react_1.default.createElement("img", { src: isOpen ? assets_1.svgSystemChevronUp : assets_1.svgSystemChevronDown, role: "presentation" })),
        isOpen ? (react_1.default.createElement(Portal_1.Portal, { target: (_a = selectRef.current) !== null && _a !== void 0 ? _a : undefined },
            react_1.default.createElement("div", { className: Select_module_scss_1.default['options'], style: style },
                react_1.default.createElement("div", { className: Select_module_scss_1.default['options-container'] },
                    react_1.default.createElement(Scrollable_1.Scrollable, { scrollbar: true },
                        react_1.default.createElement(react_1.default.Fragment, null, options.map((option) => (react_1.default.createElement(SelectOption_1.SelectOption, { key: option.id, id: option.id, value: option.value, label: option.label, disabled: option.disabled, onClick: selectHandler, selected: selected.value === option.value }))))))))) : null));
}
exports.default = Select;
